var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"q-app"}},[_c('div',{staticClass:"whiteBorder"}),_c('div',{staticClass:"borders"}),(!_vm.isBooting)?_c('router-view'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }